export const headers = [
    { text: "ID", align: "center", value: "userName" },
    { text: "이름", align: "center", value: "givenName" },
    { text: "부서", align: "center", value: "department" },
    { text: "직책", align: "center", value: "position" },
    { text: "전화번호", align: "center", value: "officePhoneNumber" },
    { text: "내선", align: "center", value: "internalNumber" },
    { text: "이메일", align: "center", value: "email" },
    { text: "모바일", align: "center", value: "phoneNumber" },
    { text: "편집", align: "center", value: "actions" },
];
export const registMemberInputs = [
    {
        label: "ID",
        key: "userName",
        column_name: "userName",
        col: "12",
        sm: "6",
        lg: "6",
        value: "",
        rules: [
            (v) => !!v || "ID 입력",
            (v) => !!(v && /[a-zA-Z]/.test(v)) || "형식 확인(영문 대소문자)",
        ],
    },
    {
        label: "이름",
        key: "givenName",
        column_name: "givenName",
        col: "12",
        sm: "6",
        lg: "6",
        value: "",
        rules: [
            (v) => !!v || "이름 입력",
            (v) => !!(v && /[가-힣]/.test(v)) || "형식 확인(한글)",
        ],
    },
    {
        label: "부서",
        key: "department",
        column_name: "department",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        rules: [(v) => !!v || "부서 선택"],
    },
    {
        label: "직책",
        key: "position",
        column_name: "position",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        rules: [(v) => !!v || "직책 선택"],
    },
    {
        label: "전화번호",
        key: "officePhoneNumber",
        column_name: "officePhoneNumber",
        col: "12",
        sm: "6",
        lg: "6",
        value: "070-000-0000",
        rules: [
            (v) => !!v || "전화번호 입력",
            (v) => !!(v &&
                /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))-(\d{3,4})-(\d{4})$/.test(v)) || "번호 형식 확인(070 시작, 숫자만 입력,자동 하이픈)",
        ],
    },
    {
        label: "내선",
        key: "internalNumber",
        column_name: "internalNumber",
        col: "12",
        sm: "6",
        lg: "6",
        value: "02-0000-0000",
        rules: [
            (v) => !!v || "내선번호 입력",
            (v) => !!(v && /[0-9]$/.test(v)) || "숫자만 입력",
        ],
    },
    {
        label: "이메일",
        key: "email",
        column_name: "email",
        col: "12",
        sm: "6",
        lg: "6",
        value: "@pionelectric.com",
        rules: [
            (v) => !!v || "이메일 입력",
            // v => !!(v &&  /^[A-Za-z0-9_\\.\\-]+@gmail.com+/.test(v) ) || '이메일 형식 확인(@gmail.com)', // for test
            (v) => !!(v && /^[A-Za-z0-9_\\.\\-]+@pionelectric.com+/.test(v)) ||
                "이메일 형식 확인(@pionelectric.com)", // origin
        ],
    },
    {
        label: "휴대전화번호",
        key: "phoneNumber",
        column_name: "phoneNumber",
        col: "12",
        sm: "6",
        lg: "6",
        value: "010-0000-0000",
        rules: [
            (v) => !!v || "휴대전화번호 입력",
            (v) => !!(v && /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))-(\d{4})$/.test(v)) ||
                "번호 형식 확인(ex : 010-1234-5678)",
        ],
    },
];
